import { render, staticRenderFns } from "./VoucherType.vue?vue&type=template&id=4818cf66&"
import script from "./VoucherType.vue?vue&type=script&lang=js&"
export * from "./VoucherType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports